import React from "react";
import CashGenericSkeleton from "./CashGenericSkeleton";

function CashDetailSkeleton() {
  return (
    <>
      <CashGenericSkeleton />
    </>
  );
}

export default CashDetailSkeleton;
